/** Prévia de uma linha para a lista de conversas do inbox. */
export function formatConversationPreview(
  content?: string | null,
  maxLen = 72,
): string {
  if (!content?.trim()) return 'Sem mensagens recentes';

  let text = content
    .replace(/<[^>]+>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  const lower = text.toLowerCase();
  if (lower.startsWith('[imagem]') || lower.includes('image/')) text = '📷 Imagem';
  else if (lower.startsWith('[áudio]') || lower.startsWith('[audio]')) text = '🎤 Áudio';
  else if (lower.startsWith('[vídeo]') || lower.startsWith('[video]')) text = '🎬 Vídeo';
  else if (lower.startsWith('[documento]') || lower.startsWith('[arquivo]')) text = '📎 Documento';
  else if (lower.startsWith('[sticker]')) text = '😊 Sticker';

  if (text.length <= maxLen) return text;
  return `${text.slice(0, maxLen).trim()}…`;
}
